<template>
  <div>
    <div id='printable' class="container-fluid p-3" >
      <!-- invoice header -->
      <b-row>
        <b-col sm="12">
        <b-img src="img/brand/Money-Receipt-Header.png" style="width: 100%;" height="auto" />
        </b-col>
      </b-row>
      <b-form @submit='onProcess' @reset='onCancel'>
        <!-- Invoice no & date -->
        <b-row class="pt-2" align-h="between">
          <!-- no -->
          <b-col sm="3" >
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Receipt No#:</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="no" type="text"
              v-model="invoice.number"  
              readonly
              ></b-form-input>
            </b-input-group> 
          </b-col>
          <!-- date -->
          <b-col sm="3" class="pl-0">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Date</strong>
                  <!-- <strong v-else>Govt.ID</strong> -->
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="date" type="date" :disabled='noInput'
              v-model="invoice.date"
              >
              </b-form-input>
            </b-input-group> 
          </b-col>
        </b-row>    
        <!-- Invoice details -->
        <b-row class="pt-2">
          <!-- pilgrim name -->
          <b-col sm="12" >
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Received with thanks from</strong>
                  <!-- <strong v-else>এইচ এল আইডিঃ</strong> -->
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="name" type="text" :disabled='noInput'
              v-model="invoice.pilgrimName"  
              ></b-form-input>
            </b-input-group> 
          </b-col>
          <!-- addr -->
          <b-col sm="12" class="pt-2">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Address</strong>
                  <!-- <strong v-else>Govt.ID</strong> -->
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="addr" type="text" :disabled='noInput' 
              v-model="invoice.addr"
              ></b-form-input>
            </b-input-group> 
          </b-col>
          <!-- amount -->
          <b-col sm="4" class="pt-2">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Amount</strong>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="tk" type="text" :disabled='noInput'
              v-model="invoice.amount"
              :formatter="taka"
              lazy-formatter
              ></b-form-input>
            </b-input-group> 
          </b-col>
          <!-- on account of -->
          <b-col sm="" class="pt-2">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">on account of</strong>
                  <!-- <strong v-else>Govt.ID</strong> -->
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="accountOf" type="text" :disabled='noInput'
              v-model="invoice.onAccountOf"
              ></b-form-input>
            </b-input-group> 
          </b-col>
          <!-- amount in words -->
          <b-col sm="12"  class="pt-2 ">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Amount in words</strong>
                  <!-- <strong v-else>Govt.ID</strong> -->
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="word" type="text" :disabled='noInput'
              v-model="invoice.amountInWord"
              ></b-form-input>
            </b-input-group> 
          </b-col>
        </b-row >

        <!-- the question- payment type -->
        <b-row class="pt-1 pl-1">
          <b-col sm="2" class="">
            <strong v-if="english">Payment Type</strong>
          </b-col>
          <!-- cash/check -->
          <b-col class="p-0 m-0" sm="4" >
            <b-form-checkbox
            plain
            v-model="invoice.paymentType.type"
            value="cash"
            unchecked-value=""
            inline
            >
            <strong v-if="english">Cash</strong>
            </b-form-checkbox>
            <b-form-checkbox
            plain
            v-model="invoice.paymentType.type"
            value="check"
            unchecked-value=""
            inline
            >
            <strong v-if="english">Check</strong>
            </b-form-checkbox>
          
          </b-col>
        </b-row>
        <!-- cash form -->
    
        <!-- check details collapse -->
        <b-row class="pt-1">
          <!-- if cash -->
          <!-- bank name -->
          <b-col sm="4" class="">
            <b-collapse id="companionForm" v-model="showCheckFrom">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text >
                    <strong v-if="english">Bank Name</strong>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="tk" 
                v-model="invoice.paymentType.bankName" 
                placeholder="bank" />
              </b-input-group>
            </b-collapse>
          </b-col>
          <!-- Check no -->
          <b-col sm="4" class="pl-0">
            <b-collapse id="companionForm" v-model="showCheckFrom">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text >
                    <strong v-if="english">Check No:</strong>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="tk"
                v-model="invoice.paymentType.checkNo" 
                placeholder="double check the number" />
              </b-input-group>
            </b-collapse>
          </b-col>
          <!-- check date -->
          <b-col sm="4" class="pl-0" >
            <b-collapse id="companionForm" v-model="showCheckFrom">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text >
                    <strong v-if="english">Check date</strong>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="tk" type="date"
                v-model="invoice.paymentType.date" 
                placeholder="double check the number" />
              </b-input-group>
            </b-collapse>
          </b-col>
        </b-row>
      
        <!-- rby & auth  -->
        <b-row align-h="between" class="pt-2">
          <!-- Received by -->
          <b-col sm="4" class="">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Received by</strong>
                  <!-- <strong v-else>Govt.ID</strong> -->
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="rBy" type="text" autofocus required
              v-model="invoice.receivedBy"
              ></b-form-input>
            </b-input-group> 
          </b-col>
          <b-col sm="" class="text-right pt-3">
            <h5>
              <p>
              ________________________
              <!-- এজেন্সীর মালিক/ প্রতিনিধির স্বাক্ষর -->
              Authorization Signatiure 
              </p>
            </h5>
          </b-col>
          <!-- authorise by -->
          <!-- <b-col sm="4" class="">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text >
                  <strong v-if="english">Authorise</strong>
                  
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="auth" type="text"
              v-model="invoice.receivedBy"
              ></b-form-input>
            </b-input-group> 
          </b-col> -->
        </b-row> 

        <!-- invoice footer -->
        <!-- <b-row>
          <b-col sm="12">
          <b-img src="img/Money Reciept-footer-03.png" style="width: 100%;" height="40" />
          </b-col>
        </b-row> -->
        <!-- buttons -->
        <b-row id='buttons' class="form-group pt-2" align-h="around">
          <b-col cols="3">
          <b-button type='submit' :disabled="show" >
              process & print
            <div>
            <b-spinner v-if="show" type="grow" variant="danger" label="processing" ></b-spinner>
            </div>
          </b-button>
          </b-col>
          <b-col cols="3">
          <b-button type='reset'>
            cancel
          </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <!-- label Customer Copy -->
    <div id='label' class="text-center text-monospace">
      <br/><br/><br/><br/><br/><br/>
      <p id='label' style="font-size: 17px;">******Customer's Copy*******************Customer's Copy*******************Customer's Copy******</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueNotifications from 'vue-notifications'
import { error } from 'util';
export default {
  name: 'invoice',
    computed: {
      tk:{
        get(){
          // return this.formatToBDT(this.invoice.amount);
        },
        set(val){
          this.invoice.amount = parseFloat((val.replace('BDT','')).replace(/,/g,''));
        }
      },
      showCheckFrom:{
        get(){
          if(this.invoice.paymentType.type == "check" ){
            return true;
          }
          else return false;
        },
        set(val){

        }
      }
    },
    
    created(){
      if(typeof this.$route.params.pay.invoice == 'object'){
        this.invoice.pilgrimName = this.$route.params.pay.invoice.name;
        this.invoice.onAccountOf = this.$route.params.pay.invoice.purpose;
        this.invoice.addr = this.$route.params.pay.invoice.addr;

        this.invoice.addr = this.invoice.addr.vhr +", "+ this.invoice.addr.po +", " +this.invoice.addr.policeStation 
        + ", "+this.invoice.addr.district +"-"+ this.invoice.addr.pc;

        this.taka(this.$route.params.pay.invoice.amount);
        this.noInput = true;
      }
      var d = new Date();
      this.invoice.date = d.getFullYear() + "-" +('0' + (d.getMonth()+1)).slice(-2) + '-' + ( '0'+ d.getDate()).slice(-2) ;
      // console.log(this.invoice.date);
    },
    updated(){
      // console.log(this.invoice.date);
    },
    data(){
      return{
        // showCheckForm:true,
        english:"true",
        success:false,
        show:false,
        noInput:false,
        componentKey: 0,
        invoice:{
          number:null,
          date:"",
          pilgrimName:"",
          addr:"",
          amount:0,
          amountInWord:"",
          onAccountOf:"",
          by_whom:"",
          paymentType:{
            type:"cash",
            checkNo:"",
            bankName:"",
            checkDate:""
          }
        }
      }
    },
    methods:{
      toNumber(val){
        return parseFloat((val.toString().replace(/[A-Z]|[a-z]|,/g ,'')));
      },
      formatToBDT(val){
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(this.toNumber(val));
      },
      taka:function(val, evt){ //convert to words
        let a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
        let b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];
        //clean amount
        this.invoice.amount = this.toNumber(val);
        if ((this.invoice.amount = this.invoice.amount.toString()).length > 9) return 'overflow';
        let n = ('000000000' + this.invoice.amount).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return; let str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : 'only';
        // set word value
        this.invoice.amountInWord=str.replace(/\W+(.)/g, function(match, chr){
          return chr.toUpperCase();
        }).replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); });
        //unclean amount
        this.invoice.amount = this.formatToBDT(val);
        return this.invoice.amount;
        // return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(this.invoice.amount);
      },
      getInvoiceID(){
        // return axios.get(  'http://192.168.100.107:8080/pilgrimDB/invoiceID.php', {withCredentials: true} )
        return axios.get( 'pilgrimDB/invoiceID.php', {withCredentials: true} )
        .then(response=>{
          this.invoice.number = response.data[0]['LAST_INSERT_ID()'];
        })
        .catch(error=>{
          if(!error.response){
            this.showErrorMsg({title:"Network Error!!"})
          }
          else{
            this.showErrorMsg({title:error.response})
          }
          console.log(error);
          this.show = false

        });
      },
      addInvoice(){ //puts values into DB
        this.invoice.amount = this.toNumber(this.invoice.amount); //clean number, take no chance
        var plainInvoice ="", plainWho="", HLID_="";
        if(typeof this.$route.params.pay.who == 'object'){
          HLID_ = this.$route.params.pay.who.HLID;
          this.$route.params.pay.who.payment.paid+= this.invoice.amount;
          this.$route.params.pay.who.payment.count+= 1;
          plainWho = JSON.stringify(this.$route.params.pay.who,null,0);
        }
        else{
          plainWho='no';
          HLID_='custom';
        }
        plainInvoice = JSON.stringify(this.invoice,null,0);
        // return axios.get(`http://192.168.100.107:8080/pilgrimDB/add_invoice.php`,{
        return axios.get( `pilgrimDB/add_invoice.php`,{
          params:{ 
            HLID: HLID_,
            invoiceNo:this.invoice.number,
            invoice: plainInvoice,
            who: plainWho
          }, withCredentials: true
        })
        .then(response => {
          if(response.data=='1'){
            this.showInfoMsg({title:"Money receipt processed!", timeout:3000})
            this.success = true
            this.show = false
            // console.log(this.success)
            // return response.data;
          }
          else{
            this.success=false;
            this.showErrorMsg({title:"something went wrong"})
          }
        })
        .catch(error => {
          if(!error.response){
            this.showErrorMsg({title:"Network Error!!"})
          }
          else{
            this.showErrorMsg({title:error.response})
          }
          this.show = false
          this.success=false;
          console.log(error);
        });
      },
      onProcess(evt){
        evt.preventDefault();
        this.show = !this.show;     
        // this.printReceipt("printable") //print
        this.getInvoiceID() //get id
        .then(()=>{
          if(!isNaN(this.invoice.number)){ //if db return a id
            this.addInvoice() //add invoice to db
            .then( () => {
              if(this.success){ //if added to db
                this.printReceipt("printable") //print
                this.$router.push('/pilgrimage/manage') //go to haven
              }
            })
          }
        });
      },
      onCancel(evt){
        evt.preventDefault();
        // alert('hello');
        this.show = false;
        this.noInput=false;
        this.$router.push('/pilgrimage/manage')        
      },
      printReceipt(div){
        var section = document.getElementById("printable");
        var clone = section.cloneNode(true);
        document.getElementById("body").appendChild(clone);
        window.print();
        section = document.getElementById("body");
        section.removeChild(section.childNodes[1]);
        // section.removeChild(section.childNodes[1]);
      }
    },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
}
</script>
<style>
#no,#name,#addr,#date,#word,#tk,#accountOf,#by,#rBy,#auth
  {
    color:black !important;
    font-size: 16px !important;
    /* border: none !important; */
    /* box-shadow: none !important; */
    /* outline: none !important; */
  }
#label
{
  visibility: hidden;
}
  /* #no,#name,#addr,#date,#word,#tk,#accountOf,#by { display: block; } */
  @media print
  {
      #label{
        visibility: visible;
      }
      #buttons { display: none; }
      #no,#name,#addr,#date,#word,#tk,#accountOf,#by, #label{
        display: block; 
        font-size: 18px !important;

        /* background-color: white; */
        /* height: 50%; */
        /* width: 50%; */
        /* position: fixed; */
        top: 0mm;
        /* left: 0; */
        margin: 0mm;
        box-shadow: 0;
        /* padding: 25px; */
        /* font-size: 20px; */
        /* line-height: 18px; */
      }
      #non-printable { display: none; }

  }
  @page { 
    size:"A4";  
    margin: 0mm; 
    width: 210mm;
    height: 297mm;
    display: block;
    margin-top: 0.0mm;
  }

</style>